import { api } from './request';

export interface UsageSummary {
  periodStart: number;
  periodEnd: number;
  clicks: number;
  freeClicks: number;
  billableClicks: number;
  estimatedAmount: number;
  freePercent: number;
  pricePerK: number;
  isCustom: boolean;
}

export interface Invoice {
  id: string;
  organization_id: string;
  period_start: number;
  period_end: number;
  clicks_total: number;
  clicks_free: number;
  clicks_billed: number;
  amount: number;
  status: 'draft' | 'issued' | 'paid';
  created_at: number;
}

export interface OrgBillingConfig {
  id: string;
  organization_id: string;
  org_name: string | null;
  free_clicks: number;
  price_per_1k: number;
  note: string | null;
  created_at: number;
  updated_at: number;
}

export const billingApi = {
  getUsage: () => api.get<UsageSummary>('/billing/usage'),
  getInvoices: (page = 1) => api.get<Invoice[]>(`/billing/invoices?page=${page}`),
  adminListConfigs: () => api.get<OrgBillingConfig[]>('/admin/billing/configs'),
  adminUpsert: (data: { orgId: string; freeClicks: number; pricePerK: number; note?: string }) =>
    api.post<OrgBillingConfig>('/admin/billing/configs', data),
  adminDelete: (orgId: string) => api.delete(`/admin/billing/configs/${orgId}`),
  adminSearchOrgs: (q: string) => api.get<{ id: string; name: string }[]>(`/admin/orgs?q=${q}`),
};
